import React from 'react';
import {
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useSurveyStepContext } from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepContext';
import { useChiliPiperContext } from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperContext';
import SurveyFixedFooterActions from 'Views/Onboarding/Pages/Survey/SurveyFixedFooterActions';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import PreviousButton from 'Views/Onboarding/Components/Navigator/PreviousButton';
import NextButton from 'Views/Onboarding/Components/Navigator/NextButton';
import ChiliPiperComponentInFullScreenDialog
  from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperComponentInFullScreenDialog';

function CompleteMemberConciergeScheduleMeetingLayout() {
  const {
    resource,
  } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();

  const {
    onClickPrevious,
    setOnboardingStepCollection,
  } = useSurveyStepContext();

  const doRedirect = async () => {
    try {
      const newStep = await resource.relationship(fr.relationships.redirectOnClose.name).link('related').get();
      setOnboardingStepCollection(newStep);
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to redirect to next onboarding step');
      }
    }
  };

  const {
    setOpenIFrame, showChiliPiperComponent, chiliPiperRel, handleChiliPiperExit,
  } = useChiliPiperContext(resource, doRedirect);

  return (
    (showChiliPiperComponent ? (
      <ChiliPiperComponentInFullScreenDialog chiliPiperRel={chiliPiperRel} handleChiliPiperExit={handleChiliPiperExit} />
    )
      : (
        <LottieLoadingLayout>
          <>
            <FDStack spacing={6} direction={'column'} justifyContent={'center'} alignSelf={'center'} alignItems={'center'}>
              <LottieRel relationship={resource.relationship(fr.relationships.lottie.name)} />
              <MetaControlField attr={'title'} simpleRootStyle />
              <MetaControlField attr={'subtitle'} simpleRootStyle />
            </FDStack>
            <SurveyFixedFooterActions>
              <FDStack spacing={2} direction={'row'} justifyContent={'center'}>
                <PreviousButton
                  onClick={onClickPrevious}
                />
                {resource.withRelationship(fr.relationships.scheduleChiliPiperMeeting.name, (rel) => (
                  <NextButton
                    onClick={() => {
                      setOpenIFrame(true);
                    }}
                    buttonLabel={rel.meta('prompt')}
                  />
                ),
                () => null)}
              </FDStack>
            </SurveyFixedFooterActions>
          </>
        </LottieLoadingLayout>
      )
    )
  );
}

CompleteMemberConciergeScheduleMeetingLayout.propTypes = {
};

CompleteMemberConciergeScheduleMeetingLayout.defaultProps = {
};

export default CompleteMemberConciergeScheduleMeetingLayout;
